
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#2196F3","stroke-width":"2","transform":"translate(4 6)"}},[_c('rect',{attrs:{"width":"30","height":"21","x":"1","y":"5","fill":"#CCE8FF","rx":"2"}}),_c('path',{attrs:{"fill":"#FFF","d":"M2 5a1 1 0 00-1 1v4.5A5.5 5.5 0 006.5 16h19a5.5 5.5 0 005.5-5.5V6a1 1 0 00-1-1H2z"}}),_c('rect',{attrs:{"width":"8","height":"4","x":"12","y":"1","rx":"1"}}),_c('rect',{attrs:{"width":"6","height":"4","x":"13","y":"14","fill":"#FFF","rx":"1"}})])])
          )
        }
      }
    